module.exports = __webpack_public_path__ + "static/media/bear_bedroom_asleep.177333a4.png";